import { records } from '@/mock/data'
import type { BusinessRecord, PageQuery, PagedResult } from '@/types/business'

const wait = (ms = 180) => new Promise(resolve => setTimeout(resolve, ms))

export const mockApi = {
  async list(query: PageQuery): Promise<PagedResult<BusinessRecord>> {
    await wait()
    let result = [...records]
    if (query.keyword) result = result.filter(item => `${item.name}${item.code}${item.owner}`.includes(query.keyword))
    if (query.region) result = result.filter(item => item.region === query.region)
    if (query.status) result = result.filter(item => item.status === query.status)
    if (query.category.length) result = result.filter(item => query.category.includes(item.category))
    const start = (query.page - 1) * query.pageSize
    return { list: result.slice(start, start + query.pageSize), total: result.length }
  },
  async detail(id: string): Promise<BusinessRecord | undefined> {
    await wait(120)
    return records.find(item => item.id === id)
  },
  async create(input: Partial<BusinessRecord>): Promise<BusinessRecord> {
    await wait(260)
    return { ...records[0], ...input, id:`mock-created-${Date.now()}`, code:`GX-DEMO-${Date.now().toString().slice(-4)}`, updatedAt:'刚刚', status:'待处理' }
  }
}
